module.exports = __webpack_public_path__ + "static/media/af.4cbaf3d5.svg";